import { FormEvent, useEffect, useState } from 'react';
import { Input, Textarea } from '../ui/Input';
import { Button } from '../ui/Button';
import { api } from '../../lib/api';
import type { FAQ } from '@bharat-consultancy/shared';

export function FAQEditor({ serviceId }: { serviceId?: string }) {
  const [faqs, setFaqs] = useState<FAQ[]>([]);
  const [form, setForm] = useState({ question: '', answer: '' });
  const [isLoading, setIsLoading] = useState(true);

  function loadFaqs() {
    api.admin.content
      .faqs(serviceId)
      .then((res) => setFaqs(res.faqs))
      .catch(() => setFaqs([]))
      .finally(() => setIsLoading(false));
  }

  useEffect(() => {
    loadFaqs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceId]);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (!form.question.trim() || !form.answer.trim()) return;
    try {
      await api.admin.content.createFaq({ serviceId, question: form.question, answer: form.answer });
      setForm({ question: '', answer: '' });
      loadFaqs();
    } catch {
      alert('Could not add FAQ. Please try again.');
    }
  }

  if (isLoading) return null;

  return (
    <div>
      <form onSubmit={handleSubmit} className="space-y-3 rounded-lg border border-line bg-white p-4">
        <Input placeholder="Question" value={form.question} onChange={(e) => setForm({ ...form, question: e.target.value })} />
        <Textarea
          placeholder="Answer"
          rows={2}
          value={form.answer}
          onChange={(e) => setForm({ ...form, answer: e.target.value })}
        />
        <Button type="submit" size="sm">
          Add FAQ
        </Button>
      </form>

      <div className="mt-4 space-y-2">
        {faqs.map((faq) => (
          <div key={faq.id} className="rounded border border-line bg-paper p-3">
            <p className="text-sm font-medium text-ink">{faq.question}</p>
            <p className="mt-1 text-sm text-ink/60">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
